var F={50:"#F5F8FD",100:"#EBF1FA",200:"#D7E3F6",300:"#9BB8E8",400:"#5687D9",500:"#3872D2",600:"#3061B3",700:"#275093",800:"#1C3969"};export{F as default};
